var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { AsyncRequestStatus } from "@ane/core/lib/models/IAsyncWrapper";
import { RestServiceBase } from "@ane/core/lib/services/RestServiceBase";
import { continuationErrorMessage } from "../constants/FeatureDataConstants.js";
import { onError } from "@ane/core/lib/decorators/OnError";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
class GatingResource extends RestServiceBase {
  constructor() {
    super(EnvironmentService.endpoints.gatesService, "/api/v1/");
  }
  getActiveGates(tenantName, entityId) {
    return __async(this, null, function* () {
      let data = yield this.getActiveGatesInternal(tenantName, entityId, false);
      for (var key in data) {
        if (key.endsWith("-0")) {
          data = yield this.getActiveGatesInternal(tenantName, entityId, true);
          break;
        }
      }
      const result = {
        status: AsyncRequestStatus.Completed,
        data
      };
      return result;
    });
  }
  updateGate(gate) {
    return __async(this, null, function* () {
      const address = `tenants/${gate.gateType.tenantName}/gateSets/${gate.entityId}/gates/${gate.id}`;
      const response = yield this._put(gate, address);
      response.ensureSuccess();
    });
  }
  getActiveGatesInternal(tenantName, entityId, aggregateParents) {
    return __async(this, null, function* () {
      const url = `tenants/${tenantName}/gateSets/${entityId}/gates/active?parseType=FullGraph&aggregateParentGates=${aggregateParents}`;
      return (yield this._get(url)).getSuccessData();
    });
  }
  getActiveGatesInternalV2(tenantName, entityId, aggregateParents) {
    return __async(this, null, function* () {
      const url = `tenants/${tenantName}/gateSets/${entityId}/gates/active?parseType=FullGraph&aggregateParentGates=${aggregateParents}`;
      return yield this._get(url);
    });
  }
}
__decorateClass([
  onError({
    message: `There was an error while obtaining the gates for this feature. ${continuationErrorMessage}`,
    defaultResult: { status: AsyncRequestStatus.Failed },
    throwExceptions: false
  })
], GatingResource.prototype, "getActiveGates", 1);
__decorateClass([
  onError({ message: `There was an error while updating gate. ${continuationErrorMessage}` })
], GatingResource.prototype, "updateGate", 1);
const GatingResource$1 = new GatingResource();
export {
  GatingResource,
  GatingResource$1 as default
};
//# sourceMappingURL=GatingResource.js.map
